import { useRef } from 'react';
import _ from 'lodash';

import { call } from 'utils';

/**
 * Call onChange function in the same render cicle every time the content of value changes.
 *
 * @param {*} value the watched value
 * @param {function} onChange callback function (newValue, oldValue) => void
 */
const useValueChange = (value, onChange) => {
  const oldValue = useRef(value);

  if (!_.isEqual(value, oldValue.current)) {
    try {
      call(onChange, value, oldValue.current);
    } finally {
      oldValue.current = _.cloneDeep(value);
    }
  }
};

export default useValueChange;
